import { loadJs } from "@use/load-js";

/**
 * Cache used to keep track of the request to load the MathJax script from the
 * remote cdn, so we only trigger it once
 */

/**
 * Helper that'll load the MathJax javascript from the remote CDN.
 */
export async function loadMathJax(): Promise<void> {
    return loadJs("https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS-MML_HTMLorMML");
}
